import { Component, ViewEncapsulation, ElementRef, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

import { ModalService } from './../../../services/modal.service';

@Component({
    selector: 'jw-modal',
    templateUrl: 'modal.component.html',
    styleUrls: ['modal.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ModalComponent implements OnInit, OnDestroy {
    @Input() id?: string;
    @Input() isDelete?: boolean = false;
    @Output() confirmation ?= new EventEmitter<boolean>();

    isOpen = false;
    private element: any;

    constructor(private modalService: ModalService, private el: ElementRef) {
        this.element = el.nativeElement;
    }

    ngOnInit() {
        // add self (this modal instance) to the modal service so it can be opened from any component
        this.modalService.add(this);

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        document.body.appendChild(this.element);

        // close modal on background click
        // Cierra el modal al dar click fuera del modal
       /* this.element.addEventListener('click', (el: any) => {
            if (el.target.className === 'jw-modal') {
                this.close();
            }
        }); */
    }

  /*   autoCLosed(opcion:boolean =false){
         // close modal on background click
         if(!opcion){
         this.element.addEventListener('click', (el: any) => {
                if (el.target.className === 'jw-modal') {
                    this.close();
                }
            });
        }
    } */

    ngOnDestroy() {
        // remove self from modal service
        this.modalService.remove(this);

        // remove modal element from html
        this.element.remove();
    }

    open() {
        this.element.style.display = 'block';
        
        document.body.classList.add('jw-modal-open');
        this.isOpen = true;
    }
    

    close() {
        this.element.style.display = 'none';
        document.body.classList.remove('jw-modal-open');
        this.isOpen = false;
    }

    confirm() {
        this.confirmation.emit(true);
    }
}